module.exports = __webpack_public_path__ + "static/media/chaveiro.f2c3231a.svg";